import React, { useEffect, useRef, useState } from "react";
import "../styles/topbar.css";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, styled } from "@mui/material";
import Swal from "sweetalert2";
import { ls } from "../../../variables";
import { useStateValue } from "../../../Hooks/stateProvider";
import axios from "axios";
import Dropwdown from "./Dropwdown";

const StyledButton = styled(Button)(() => ({
  backgroundColor: "#154063",
  boxShadow: "none !important",
  height: "0",
  ":focus, :active": {
    boxShadow: "none !important",
  },
  ":hover": {
    backgroundColor: "#154063 !important", // Force the same color on hover
  },
}));

const navDataMap = {
  ALERT_PMS: [
    { name: "Submission Page", path: "upload" },
    { name: "Tracker Page", path: "tracker" },
  ],
  ALERT_SEBI: [
    { name: "Upload Utility", path: "uploadutilityAlert" },
    { name: "Tracker Page", path: "sebiTracker" },
  ],
  CMM: [
    { name: "CMM Upload", path: "cmmPage" },
    { name: "CMM Tracker", path: "cmmTracker" },
  ],
  SEBI_CMM: [{ name: "CMM Tracker", path: "sebiCmmTracker" }],
};

const TopBar = () => {
  const navigate = useNavigate();
  const [{ moduleType }, dispatch] = useStateValue();
  const [open, setOpen] = useState(false);
  const userType = ls.get("userType");
  const location = useLocation();
  const url = location.pathname;
  const overlayRef = useRef(null);

  // Handle logout
  const handleLogout = () => {
    Swal.fire({
      title: "Are you sure you want to log out?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#154063",
      cancelButtonColor: "#d33",
      confirmButtonText: "OK",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .post("/api/pms/logout", {
            email: ls.get("email")
          })
          .then((res) => {
            ls.removeAll();
            navigate("/");
          })
          .catch((error) => {
            console.error("Error during logout:", error);
          });
      }
    });
  };

  // Handle clicks outside the dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (overlayRef.current && !overlayRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  // Determine navigation data based on URL and user type
  const getNavigationData = () => {
    if ((moduleType === "ALERT" && userType === "PMS") ||
      (userType === "RTA" && moduleType === "ALERT")) {
      return navDataMap.ALERT_PMS;
    }
    if (moduleType === "ALERT" && userType === "SEBI" && ls.get("division") === "DC") {
      return navDataMap.ALERT_SEBI;
    }
    if (url == '/app/cmmPage' || url == '/app/cmmTracker' || url == "/app/cmmView") {
      return navDataMap.CMM;
    }
    
    if (url === "/app/sebiCmmView") {
      return navDataMap.SEBI_CMM;
    }
    return [];
  };

  // Render navigation buttons
  const NavigationButtons = ({ data }) => {
    return data.map((item, index) => (
      <div key={index}>
        <StyledButton
          className="topBarButton"
          variant="contained"
          onClick={() => {
            dispatch({ type: "fy_year", fy_year: "" });
            dispatch({ type: "quarter", quarter: "" });
            // dispatch({ type: "half_year", half_year: "" });
            dispatch({ type: "pmsName", pmsName: "" });
            navigate(item.path);
          }}
        >
          {item.name}
        </StyledButton>
      </div>
    ));
  };

  const navigationData = getNavigationData();

  return (
    <div className="topbarContainer">
      <div className="imageContainer">
        <NavigationButtons data={navigationData} />
      </div>
      <Dropwdown
        isOpen={() => setOpen(!open)}
        onClose={() => setOpen(false)}
        handleLogout={handleLogout}
        open={open}
      />
    </div>
  );
};

export default TopBar;